import styled from 'styled-components';

export const Overlay = styled.div<{$ZIndex: number}>`
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 80vw;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    z-index: ${({$ZIndex}) => $ZIndex};
`;

export const Container = styled.div`
    background: white;
    border-radius: 8px;
    padding: 24px;
    max-width: 400px;
    width: 90%;
    display: contents;
`;

export const IconWrapper = styled.div`
    //width: 48px;
    //height: 48px;
    margin-right: 20px;
    flex-shrink: 0;

    svg {
        width: 100%;
        height: 100%;
        fill: #2ca8e7;
    }
`;

export const TextContent = styled.div`
    flex-grow: 1;

    h2 {
        margin: 0;
        font-size: 2rem;
        font-weight: bold;
        color: black;
    }

    p {
        margin: 5px 0 0;
        font-size: 1.8rem;
        word-break: break-word;
        color: black;
    }
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: 10px;
`;

export const Button = styled.button<{$focused: boolean}>`
    font-size: 1.5rem;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    padding: 12px 20px;
    cursor: pointer;
    flex-shrink: 0;
    background-color: ${({$focused}) => ($focused ? '#2ca8e7' : '#ddd')};
    color: ${({$focused}) => ($focused ? 'white' : 'black')};

    &:hover {
        background-color: #1a90c6;
    }
`;
